import { _ as s } from "./main65.js";
var t = s;
function _(a) {
  return t(this.__data__, a) > -1;
}
var e = _;
export {
  e as _
};
